import { render, staticRenderFns } from "./addSensitive.vue?vue&type=template&id=48ecafb4&scoped=true&"
import script from "./addSensitive.vue?vue&type=script&lang=js&"
export * from "./addSensitive.vue?vue&type=script&lang=js&"
import style0 from "./addSensitive.vue?vue&type=style&index=0&id=48ecafb4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ecafb4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/98-prod-frontend-deploy-tke/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48ecafb4')) {
      api.createRecord('48ecafb4', component.options)
    } else {
      api.reload('48ecafb4', component.options)
    }
    module.hot.accept("./addSensitive.vue?vue&type=template&id=48ecafb4&scoped=true&", function () {
      api.rerender('48ecafb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chat/components/KeyWordSettings/addSensitive.vue"
export default component.exports